import { Box, Grid } from "@mui/material";
import {
	EmailFieldRHF,
	EnhancedRadioGroupRHFWithLabel,
	ExtensionNumberRHF,
	LabelPosition,
	PhoneNumberRHF,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";

interface IPADAgreenmentAccountHolderDetailsFieldsPanel {
	setIsJointAccount: (value: number) => void;
}
export const PADAgreenmentAccountHolderDetailsFieldsPanel: FC<
	IPADAgreenmentAccountHolderDetailsFieldsPanel
> = ({ setIsJointAccount }) => {
	const onIsJointAccountChangeHandler = (selected: any) => {
		let value = selected.target.value;
		setIsJointAccount(value)
	}
	return (
		<Box sx={{ "& .MuiTypography-root": { fontSize: ".875rem" } }}>
			<Box sx={{ "& .MuiFormLabel-root": { paddingTop: "9px" }, marginBottom: "10px" }}>
				<EnhancedRadioGroupRHFWithLabel
					label="Is it a joint Account"
					name="isJointAccount"
					selectedValue={100}
					key="isJointAccount"
					testId="isJointAccount"
					options={[
						{
							label: "Yes",
							value: 200,
						},
						{
							label: "No",
							value: 100,
						}
					]}
					// displayAsRow={false}
					labelPosition={LabelPosition.Left}
					labelColumns={6}
					fieldColumns={6}

					onChangeHandler={onIsJointAccountChangeHandler}
				/>
			</Box>
			<RHookFormTextFieldWithLabel
				id="accountHolderName"
				label="Name"
				testId={`accountHolderName`}
			/>
			{/* <RHookFormTextFieldWithLabel
				id="accountHolderEmail"
				label="Email"
				testId={`accountHolderEmail`}
			/> */}
			<EmailFieldRHF
				id="accountHolderEmail"
				label="Email"
				testId={`accountHolderEmail`}
				// labelPosition={LabelPosition.Top}
				// labelColumns={4}
				// fieldColumns={8}
			// required
			/>
			<Grid
				container
				columnSpacing={0}
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
			>
				<Grid size={{ xs: 8, sm: 8, md: 8, lg: 8, xl: 8 }}>
					<PhoneNumberRHF
						label="Phone No."
						id="accountHolderPhone"
						testId={`phone`}
					/>
				</Grid>
				<Grid
					size={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }}
				></Grid>
				<Grid size={{ xs: 3, sm: 3, md: 3, lg: 3, xl: 3 }}>
					<ExtensionNumberRHF
						label="Ext."
						id="accountHolderExt"
						testId={`ext`}
					/>
				</Grid>
			</Grid>
		</Box>
	);
};
